export enum LOGIN_ACCESS_TYPE {
  WEB = 'W',
  MOBILE = 'M',
}
